// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import $ from 'jquery'
import axios from './factory-api/https-v3'
import store from './store/store'
import VueCookies from 'vue-cookies'
// import Mint from 'mint-ui'
import appConfig from './appConfig'
// import 'mint-ui/lib/style.css'
import '../static/js/gt'
import Base64 from 'js-base64'

import Vant from 'vant'
// import { Toast } from 'vant';
import 'vant/lib/index.css'

Vue.use(Vant)
// Vue.use(Toast)
// Vue.prototype.$toast = Vant.Toast

import scroll from 'vue-seamless-scroll'

Vue.use(scroll)

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

//表单验证
import './util/validate'

//引入公共组件
import AssetForm from "@/components/office-automation/administrative/assetForm.vue"
import Procurement from '@/components/office-automation/administrative/procurement.vue'
Vue.component("AssetForm",AssetForm)
Vue.component("Procurement",Procurement)

Vue.use(ElementUI)
Vue.prototype.$Base64 = Base64.Base64
Vue.prototype.$bus = new Vue()
Vue.prototype.$loading = ElementUI.Loading.service
Vue.prototype.$msgbox = ElementUI.MessageBox
Vue.prototype.$message = ElementUI.Message
Vue.prototype.$notify = ElementUI.Notification

//引用对象存储SDK
import uploadFile from './factory-api/uploadFile'
import uploadFileBatch from './factory-api/uploadFileBatch'
//单文件上传
Vue.prototype.$uploadFile = uploadFile
//批量文件上传
Vue.prototype.$uploadFileBatch = uploadFileBatch

import uploadAxios from './factory-api/upload-https'
import httpsV3 from './factory-api/https-v3'

Vue.prototype.$http = axios
Vue.prototype.$uploadHttp = uploadAxios
Vue.prototype.$httpV3 = httpsV3

Vue.use(VueCookies)
// Vue.use(Mint)
Vue.use(router)
Vue.use(store)
Vue.config.productionTip = false
Vue.prototype.$http = axios

//引入分享插件
import '../static/js/jquery.share.min'

import './util/index'

let setCookie = (c_name, value, expiredays) => {
  let exdate = new Date()
  exdate.setDate(exdate.getDate() + expiredays)
  document.cookie = c_name + '=' + escape(value) + ';path=/'
    // + (appConfig.API.DOMAIN_NAME ? ';domain=' + appConfig.API.DOMAIN_NAME : '')
    + ((expiredays === null) ? '' : ';expires=' + exdate.toGMTString()) + ';path=/'
}

let delCookie = (name) => {
  let exp = new Date()
  exp.setTime(exp.getTime() - 1)
  let cval = getCookie(name)
  if (cval !== null) document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString()
}
let getCookie = (name) => {
  let arr, reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
  if (arr = document.cookie.match(reg)) {
    return (arr[2])
  } else {
    return null
  }
}

//格式化用户信息
let userFormat = (userInfo, route = '') => {
  if (userInfo) {
    //后台用户，需要跳转后台
    if (Number(userInfo.platformCategory) === 20) {
      //跳转后台
      window.location.href = appConfig.API.BACKSTAGE_URL
    }

    //初始化用户名
    if (userInfo.realName) {
      userInfo.name = userInfo.realName
    } else if (userInfo.nickName) {
      userInfo.name = userInfo.nickName
    } else {
      userInfo.name = userInfo.loginName
    }
    userInfo.id = userInfo.userId
    //初始化手机号
    userInfo.phone = userInfo.mobilePhone
    //初始化头像
    userInfo.icon = userInfo.headIconUrl

    store.commit('updateUserInfo', userInfo)
    //初始化当前关联企业信息
    if (userInfo.currentCompanyId) {
      store.commit('updateCompany', {
        id: userInfo.currentCompanyId,
        name: userInfo.currentCompanyName,
        isAdmin: userInfo.currentCompanyIsAdmin
      })
      store.commit('updateCompanyId', userInfo.currentCompanyId)
    } else {
      store.commit('updateCompany', '')
      store.commit('updateCompanyId', '')
    }

    // window.localStorage.setItem('userInfo', JSON.stringify(userInfo))
    setCookie('userInfo', JSON.stringify(userInfo))
  } else {
    console.log('获取用户信息为空')
    //是否需要登录
    if (route && route.meta.requireAuth) {
      console.log('跳转')
      //跳转登录页
      window.location.href = '/login?redirect=' + route.path
    } else {
      // window.localStorage.setItem('userInfo', "")
      delCookie('userInfo')

      store.commit('updateUserInfo', '')
      store.commit('updateCompany', '')
      store.commit('updateCompanyId', '')
    }
  }
}

router.beforeEach((to, from, next) => {
  //获取token信息
  let token = getCookie('token')
  console.log(token)
  if (token) {
    token = unescape(token)
    store.commit('updateToken', token)
  } //else {
  //   setCookie('token', '')
  //   store.commit('updateToken', '')
  // }

  //获取用户信息
  // let userInfo = window.localStorage.getItem('userInfo')
  let userInfo = getCookie('userInfo')
  if (userInfo) {
    //转换特殊符号
    userInfo = unescape(userInfo)
    //转换字符串为变量
    userInfo = JSON.parse(userInfo)
  }
  userFormat(userInfo)

  // console.log(to)
  // 初始化浏览器窗口标题
  let title = []
  if (to.matched.length > 1) {
    let arr = to.matched
    arr.forEach((item) => {
      if (item.meta.title) {
        title.push(item.meta.title)
      }
    })
  } else {
    title.push(to.meta.title)
  }
  // document.title = title.reverse().join(' - ') + ' - 将来网'
  let titleString = title.reverse().join(' - ') + ' - 将来网'
  store.commit('updateTitle', titleString)

  if (token) {
    //token有效，无用户信息或用户信息与token不匹配则重新获取用户信息
    if (!userInfo) {
      httpsV3.get('user/get/by/token?needThrowExp=false')
        .then(res => {
          if (Number(res.data.code) === 10000) {
            let userInfo = res.data.data
            userFormat(userInfo, to)
          } else {
            console.log('获取用户信息失败：' + res.data.msg)

            //是否需要登录
            if (to.meta.requireAuth) {
              console.log('跳转1')
              //跳转登录页
              next({
                path: '/login',
                query: {redirect: to.path}
              })
            } else {
              // window.localStorage.setItem('userInfo', "")
              delCookie('userInfo')
              store.commit('updateUserInfo', '')
              store.commit('updateCompany', '')
              store.commit('updateCompanyId', '')
            }
          }
        })
        .catch(err => {

        })
    } else if (userInfo && Number(userInfo.platformCategory) === 20) {
      //后台用户，需要跳转后台
      window.location.href = appConfig.API.BACKSTAGE_URL
    }
  }

  //当前路由是否必须登录
  if (to.meta.requireAuth) {

    if (token) {
      next()
    } else {
      // window.location.href = to.path
      //to.fullPath
      console.log('跳转2')
      next({
        path: '/login',
        query: {redirect: to.path}
      })
    }
  } else {
    next()
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js